"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _styles = require("@mui/styles");
var _Button = _interopRequireDefault(require("@mui/material/Button"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRedux = require("react-redux");
var _react = _interopRequireWildcard(require("react"));
var _styles2 = require("@mui/material/styles");
var _surveyFiles = require("@survey/common/dist/actions/surveyFiles.actions");
var _getResource = require("../../utilities/getResource");
var _material = require("@mui/material");
var _Download = _interopRequireDefault(require("@mui/icons-material/Download"));
var _templateObject;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var styles = function styles() {
  return {
    root: {}
  };
};
var VisuallyHiddenInput = (0, _styles2.styled)('input')(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n    clip: rect(0 0 0 0);\n    clip-path: inset(50%);\n    height: 1px;\n    overflow: hidden;\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    white-space: nowrap;\n    width: 1px;\n"])));
var CustomFileUpload = /*#__PURE__*/function (_Component) {
  function CustomFileUpload(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, CustomFileUpload);
    _this = _callSuper(this, CustomFileUpload, [props]);
    (0, _defineProperty2["default"])(_this, "getFileInformation", /*#__PURE__*/(0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
      var fileName, response;
      return _regenerator["default"].wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!_this.state.fileURL) {
              _context.next = 2;
              break;
            }
            fileName = _this.state.fileURL.split('/').pop();
            _context.next = 1;
            return _this.props.getSurveyFileDetail(fileName);
          case 1:
            response = _context.sent;
            if (response.type === 'GET_SURVEY_FILE_DETAIL_SUCCESS') {
              _this.setState({
                originalFileName: response.response['originalFileName']
              });
            }
            _context.next = 3;
            break;
          case 2:
            _this.setState({
              originalFileName: ''
            });
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    (0, _defineProperty2["default"])(_this, "handleFileDownload", /*#__PURE__*/(0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2() {
      var formData, fileURL, response, blob, link, fileName;
      return _regenerator["default"].wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            formData = new FormData();
            _context2.next = 1;
            return _this.parseFileURL();
          case 1:
            fileURL = _context2.sent;
            formData.append('BucketName', 'ha-assessment-content');
            formData.append('FileName', fileURL);
            _context2.next = 2;
            return _this.props.getSurveyFile(formData);
          case 2:
            response = _context2.sent;
            if (response.type === 'GET_SURVEY_FILE_SUCCESS') {
              blob = new Blob([response.response]);
              link = document.createElement('a');
              link.href = window.URL.createObjectURL(blob);
              fileName = _this.state.originalFileName;
              link.download = fileName;
              link.click();
            } else {
              _this.setState({
                uploadResultAlertMessage: 'There was an error downloading your file.'
              });
              _this.setState({
                uploadResultAlertType: 'error'
              });
              _this.setState({
                uploadResultAlertOpen: true
              });
            }
          case 3:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    })));
    (0, _defineProperty2["default"])(_this, "handleFileUpload", /*#__PURE__*/function () {
      var _ref3 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee3(event) {
        var _this$props, entityID, surveyID, dataMappingID, file, formData, response;
        return _regenerator["default"].wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!(event.target.files[0] != null)) {
                _context3.next = 2;
                break;
              }
              _this$props = _this.props, entityID = _this$props.entityID, surveyID = _this$props.surveyID, dataMappingID = _this$props.dataMappingID;
              _this.setState({
                isFileProcessing: true
              });
              file = event.target.files[0];
              formData = new FormData();
              formData.append('File', file);
              formData.append('BucketName', 'ha-assessment-content');
              formData.append('BucketSubDirectory', 'assessment-uploads');
              formData.append('SurveyID', surveyID);
              formData.append('EntityID', entityID);
              formData.append('DataMappingID', dataMappingID);
              _context3.next = 1;
              return _this.props.saveSurveyFile(formData);
            case 1:
              response = _context3.sent;
              if (response.type === 'SAVE_SURVEY_FILE_SUCCESS') {
                _this.setState({
                  fileURL: response.response
                });
                _this.props.onChange(response.response);
                _this.setState({
                  uploadResultAlertMessage: 'Upload Complete'
                });
                _this.setState({
                  uploadResultAlertType: 'success'
                });
                _this.setState({
                  uploadResultAlertOpen: true
                });
              } else {
                _this.setState({
                  uploadResultAlertMessage: 'There was an error uploading your file.'
                });
                _this.setState({
                  uploadResultAlertType: 'error'
                });
                _this.setState({
                  uploadResultAlertOpen: true
                });
              }
              _this.setState({
                isFileProcessing: false
              });
            case 2:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      return function (_x) {
        return _ref3.apply(this, arguments);
      };
    }());
    (0, _defineProperty2["default"])(_this, "handleRemoveFile", function () {
      _this.props.removeSurveyFile(_this.props.surveyID, _this.state.fileURL).then(function () {
        _this.setState({
          fileURL: '',
          originalFileName: ''
        });
        _this.props.onChange('');
      });
    });
    (0, _defineProperty2["default"])(_this, "handleUploadResultAlertClose", function () {
      _this.setState({
        uploadResultAlertOpen: false
      });
    });
    (0, _defineProperty2["default"])(_this, "parseFileURL", /*#__PURE__*/(0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee4() {
      return _regenerator["default"].wrap(function (_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            return _context4.abrupt("return", _this.state.fileURL.replace('https://ha-assessment-content.s3.amazonaws.com/', ''));
          case 1:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    })));
    _this.state = {
      fileURL: _this.props.value,
      originalFileName: '',
      uploadResultAlertOpen: false,
      uploadResultAlertType: 'success',
      uploadResultAlertMessage: 'Upload Complete',
      isFileProcessing: false
    };
    _this.getFileInformation = _this.getFileInformation.bind(_this);
    _this.handleFileDownload = _this.handleFileDownload.bind(_this);
    _this.handleFileUpload = _this.handleFileUpload.bind(_this);
    _this.parseFileURL = _this.parseFileURL.bind(_this);
    _this.handleUploadResultAlertClose = _this.handleUploadResultAlertClose.bind(_this);
    return _this;
  }
  (0, _inherits2["default"])(CustomFileUpload, _Component);
  return (0, _createClass2["default"])(CustomFileUpload, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.getFileInformation();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.fileURL && prevState.fileURL !== this.state.fileURL) {
        this.getFileInformation();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        required = _this$props2.required,
        resources = _this$props2.resources,
        language = _this$props2.language;
      return /*#__PURE__*/_react["default"].createElement(_material.Stack, {
        spacing: 2,
        direction: "row"
      }, this.state.fileURL && this.state.originalFileName && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        variant: "text",
        startIcon: /*#__PURE__*/_react["default"].createElement(_Download["default"], null),
        onClick: this.handleFileDownload,
        disabled: this.state.isFileProcessing
      }, this.state.originalFileName.length >= 29 ? this.state.originalFileName.substring(0, 29) + '....pdf' : this.state.originalFileName), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        variant: "text",
        onClick: this.handleRemoveFile,
        disabled: this.state.isFileProcessing
      }, (0, _getResource.getResource)(resources, language, 'Label', 'Remove PDF'))), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        component: "label",
        variant: "text",
        disabled: this.state.isFileProcessing
      }, this.state.fileURL ? (0, _getResource.getResource)(resources, language, 'Label', 'Replace PDF') : (0, _getResource.getResource)(resources, language, 'Label', 'Upload PDF'), /*#__PURE__*/_react["default"].createElement(VisuallyHiddenInput, {
        type: "file",
        accept: ".pdf",
        onChange: this.handleFileUpload
      })), /*#__PURE__*/_react["default"].createElement(_material.Snackbar, {
        open: this.state.uploadResultAlertOpen,
        onClose: this.handleUploadResultAlertClose,
        anchorOrigin: {
          vertical: 'top',
          horizontal: 'right'
        },
        autoHideDuration: 6000,
        TransitionComponent: function TransitionComponent(props) {
          return /*#__PURE__*/_react["default"].createElement(_material.Slide, (0, _extends2["default"])({}, props, {
            easing: {
              enter: 'cubic-bezier(0.0, 1.0, 0.0, 1.0)',
              exit: 'linear'
            },
            direction: "right"
          }));
        }
      }, /*#__PURE__*/_react["default"].createElement(_material.Alert, {
        onClose: this.handleUploadResultAlertClose,
        severity: this.state.uploadResultAlertType,
        sx: {
          width: '100%'
        }
      }, (0, _getResource.getResource)(resources, language, 'Message', this.state.uploadResultAlertMessage))));
    }
  }]);
}(_react.Component);
CustomFileUpload.propTypes = {
  value: _propTypes["default"].string,
  required: _propTypes["default"].bool,
  onChange: _propTypes["default"].func.isRequired
};
var mapStateToProps = function mapStateToProps(state, props) {
  return {};
};
var _default = exports["default"] = (0, _styles.withStyles)(styles)((0, _reactRedux.connect)(mapStateToProps, {
  getSurveyFile: _surveyFiles.getSurveyFile,
  getSurveyFileDetail: _surveyFiles.getSurveyFileDetail,
  saveSurveyFile: _surveyFiles.saveSurveyFile,
  removeSurveyFile: _surveyFiles.removeSurveyFile
})(CustomFileUpload));